import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "../../lang";
import "./Login.scss";
import LoginForm from "./LoginForm";

const Login = ({ handleLoginSubmit }) => {
  const [t] = useTranslation();

  return (
    <div className="login-panel">
      <div className="login-panel__logo">
        <img src="/assets/img/login_plataforma_sp3.png" alt="SP3" />
      </div>
      {/* <p className="login-panel__subtitle">{t("Plataforma GPS")}</p> */}
      <LoginForm handleLoginSubmit={handleLoginSubmit} />
    </div>
  );
};

Login.propTypes = {
  handleLoginSubmit: PropTypes.func,
};

Login.defaultProps = {
  handleLoginSubmit: () => {},
};
export default Login;
